/**
 * The debug switches, for tuning on a phone. They are read from the query
 * string in dev builds only; a production build ignores them (this module
 * folds to constants, and what they switch on is dropped).
 *
 *   ?fps       show the frame meter
 *   ?s=2.5     hold the page at this scroll position, in screen heights
 *   ?t=3.5     start the intro this many seconds in
 *   ?skip      skip the intro
 *   ?intro     force the intro path even for automated browsers (navigator.webdriver)
 *   ?dpr=2     cap the canvas's pixel ratio at this, instead of the default
 */
export interface DebugSwitches {
  readonly fps: boolean
  readonly scroll: number | null
  readonly time: number | null
  readonly skip: boolean
  readonly intro: boolean
  readonly dpr: number | null
}

const OFF: DebugSwitches = {
  fps: false,
  scroll: null,
  time: null,
  skip: false,
  intro: false,
  dpr: null,
}

function read(search: string): DebugSwitches {
  const query = new URLSearchParams(search)
  function number(name: string): number | null {
    return query.has(name) ? Number(query.get(name)) : null
  }
  return {
    fps: query.has('fps'),
    scroll: number('s'),
    time: number('t'),
    skip: query.has('skip'),
    intro: query.has('intro'),
    dpr: number('dpr'),
  }
}

export const debug: DebugSwitches = import.meta.env.DEV ? read(location.search) : OFF
